import { Component, OnInit, inject } from '@angular/core';
import {FormBuilder, FormGroup, AbstractControl, ValidationErrors, ReactiveFormsModule} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ButtonSize, ButtonState, ButtonType, InputSize, InputState, MaterialType } from 'src/assets/types/dtoTypes';
import {UploadFormComponent} from "../../../../../../shared/upload-form/upload-form.component";
import {ButtonComponent} from "../../../../../../shared/button/button.component";
import {TranslateModule} from "@ngx-translate/core";
import {InputComponent} from "../../../../../../shared/input/input.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-certificate-upload-dialog',
  templateUrl: './certificate-upload-dialog.component.html',
  styleUrls: ['./certificate-upload-dialog.component.scss'],
  imports: [
    ReactiveFormsModule,
    UploadFormComponent,
    ButtonComponent,
    TranslateModule,
    InputComponent,
    NgIf
  ],
  standalone: true
})
export class CertificateUploadDialogComponent implements OnInit {
  private fb = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<CertificateUploadDialogComponent>>(MatDialogRef);

  form: FormGroup;

  uploadedFileUrl: string = '';

  showYearField = false;

  data = inject<{ userId: string }>(MAT_DIALOG_DATA);


  protected readonly InputSize = InputSize;

  protected readonly InputState = InputState;

  protected readonly ButtonType = ButtonType;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonSize = ButtonSize;

  constructor() {}

  ngOnInit(): void {
    this.form = this.fb.group( {
      certificationName: [ '' ],
      certificationYear: [ '' ],
    } );
  }

  get isFormValid(): boolean {
    return !!this.uploadedFileUrl;
  }

  numberValidator( control: AbstractControl ): ValidationErrors | null {
    const value = control.value;
    if ( value && !/^\d+$/.test( value ) ) {
      return { numberOnly: true };
    }
    return null;
  }

  onSubmit() {
    if ( this.uploadedFileUrl ) {
      const name = this.form.value.certificationName?.trim() || 'n/a';
      const year = this.showYearField ? ( this.form.value.certificationYear?.trim() || 'n/a' ) : 'n/a';

      this.dialogRef.close( {
        title: name,
        description: year,
        url: this.uploadedFileUrl,
        type: MaterialType.CV,
        userId: this.data.userId,
      } );
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  onKeyPress( event: KeyboardEvent ) {
    const charCode = event.charCode;
    if ( charCode !== 8 && charCode !== 0 && ( charCode < 48 || charCode > 57 ) ) {
      event.preventDefault();
    }
  }

  onFileUploaded( url: string ) {
    this.uploadedFileUrl = url;
  }

  protected readonly MaterialType = MaterialType;
}
